import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Ticket } from "../../services/swagger";
import { MouseEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import Authorized from "../atoms/Authorized";
import useConfirm from "../../hooks/useConfirm";
import { TicketService } from "../../services/api";
import { useNavigate } from "react-router";
import TicketPrintDialog from "../organisms/Ticket/TicketPrintDialog";
import GradingIcon from "@mui/icons-material/Grading";
import TicketPrintLogsDialog from "./TicketPrintLogsDialog";
import OptionsButton from "./OptionsButton";

interface TicketOptionsButtonProps {
  ticket: Ticket;
}

export default function TicketOptionsButton(props: TicketOptionsButtonProps) {
  const { t } = useTranslation("TicketOptionsButton");
  const { ticket } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [printDialog, setPrintDialog] = useState(false);
  const [printLogsDialog, setPrintLogsDialog] = useState(false);
  const navigate = useNavigate();
  const confirm = useConfirm();

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleOpenPrintDialog = () => {
    setPrintDialog(true);
    handleClose();
  };

  const handleOpenPrintLogsDialog = () => {
    setPrintLogsDialog(true);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseTicketPrintDialog = () => {
    setPrintDialog(false);
  };

  const handleCloseTicketPrintLogsDialog = () => {
    setPrintLogsDialog(false);
  };

  const handleDelete = () => {
    confirm(async () => {
      if (!ticket._id) return;
      const res = await TicketService.deleteTicket({
        id: ticket._id,
      });
      if (res.data.success) navigate(-1);
    });
  };

  return (
    <>
      <TicketPrintDialog
        ticket={ticket}
        open={printDialog}
        onClose={handleCloseTicketPrintDialog}
      />
      <TicketPrintLogsDialog
        open={printLogsDialog}
        ticket={props.ticket}
        onClose={handleCloseTicketPrintLogsDialog}
      />
      <OptionsButton
        options={[
          {
            icon: <PrintIcon color="primary" />,
            label: t("Print"),
            onClick: handleOpenPrintDialog,
          },
          {
            icon: <GradingIcon color="action" />,
            label: t("PrintLog"),
            onClick: handleOpenPrintLogsDialog,
          },
          { divider: true },
          {
            icon: <DeleteIcon color="error" />,
            label: t("Delete"),
            onClick: handleDelete,
          },
        ]}
        onClose={handleClose}
      />
    </>
  );
}
